import {getUserObject} from "utils/relewise";

function getFallbackPopularProducts(options) {
  return {
    BasedOn: "MostViewed",
    SinceMinutesAgo: 7200,
    Settings: {
      NumberOfRecommendations: 10,
      AllowFillIfNecessaryToReachNumberOfRecommendations: false,
      AllowReplacingOfRecentlyShownRecommendations: true,
      RecommendVariant: true,
      SelectedProductProperties: {
        DisplayName: true,
        CategoryPaths: false,
        Assortments: false,
        Pricing: true,
        AllData: false,
        ViewedByUserInfo: false,
        PurchasedByUserInfo: false,
        Brand: false,
        AllVariants: false,
        DataKeys: [
          "Vendor",
          "InStock",
          "Tags",
          "HasAnyModelImages",
          "HasNoImages",
        ],
      },
      SelectedVariantProperties: {
        DisplayName: true,
        Pricing: true,
        AllSpecifications: false,
        Assortments: false,
        AllData: false,
        DataKeys: [
          "ImageUrls",
          "InventoryQuantity",
          "HasAnyModelImages",
          "HasNoImages",
        ],
      },
      PrioritizeDiversityBetweenRequests: false,
    },
    Language: {
      Value: window.mosmosh.shop_local.iso,
    },
    User: getUserObject(),
    Currency: {
      Value: window.mosmosh.currency.iso,
    },
    RelevanceModifiers: {},
    Filters: {
      Items: [
        {
          $type:
              "Relewise.Client.Requests.Filters.ProductCategoryIdFilter, Relewise.Client",
          CategoryIds: options.collections,
          EvaluationScope: "ImmediateParent",
          TypeName: "ProductCategoryIdFilter",
          Negated: false,
        },
        {
          $type:
              "Relewise.Client.Requests.Filters.ProductIdFilter, Relewise.Client",
          ProductIds: [options.crossStoreProductId],
          TypeName: "ProductIdFilter",
          Negated: true,
        },
        {
          $type:
              "Relewise.Client.Requests.Filters.ProductDataFilter, Relewise.Client",
          Key: "Vendor",
          FilterOutIfKeyIsNotFound: true,
          MustMatchAllConditions: true,
          Conditions: {
            Items: [
              {
                $type:
                    "Relewise.Client.Requests.Conditions.EqualsCondition, Relewise.Client",
                Value: {
                  Type: "String",
                  Value: options.vendor,
                },
                TypeName: "EqualsCondition",
                Negated: false,
              },
            ],
          },
          TypeName: "ProductDataFilter",
          Negated: false,
        },
      ],
    },
    DisplayedAtLocationType: "Fallback Popular Products",
  };
}

export default getFallbackPopularProducts
